export class TimeoutsManager {

  subs: any = {};

  constructor() {
  }

  add(sub: any, id: any = -1) {
    if (id == -1) {
      id = Object.keys(this.subs).length + '';
    }
    if (this.subs[id]) {
      clearTimeout(this.subs[id]);
    }
    this.subs[id] = sub
  }

  remove(id: any = -1) {
    if (id == -1) {
      id = Object.keys(this.subs)[0];
    }
    if (this.subs[id]) {
      clearTimeout(this.subs[id]);
      delete this.subs[id];
    }
  }

  clear(id: any = -1) {
    this.remove(id);
  }

  clearAll() {
    Object.keys(this.subs).forEach((k: any) => {
      this.clear(k);
    });
  }

}
